<div class="full-content">
  <div class="feature-wrapper login">
    <div class="page-title">{{'mkb.card3dsecure.page.title' | resolve}}</div>
    <mat-card class="login-content">
      <mat-card-content>
        <div class="card-title">{{'mkb.card3dsecure.page.login.title' | resolve}}</div>
        <form [formGroup]="loginFormGroup" autocomplete="off">

          <div class="login-page-description" [innerHTML]="pageDescription | safeHtml"></div>

          <mat-error *ngIf="loginError" [ngClass]="{'multiline-error': loginError === 'phone'}">
            {{errMsg | resolve}}
          </mat-error>

          <mat-form-field class="w-200">
            <div class="filed-title">{{'mkb.card3dsecure.page.login.card.number.title' | resolve}}</div>
            <input
              matInput
              digitOnly
              maxlength="6"
              formControlName="cardLastNumber">
            <mat-error *ngIf="loginFormGroup?.get('cardLastNumber').hasError('required')">
              {{'mkb.card3dsecure.common.required.error' | resolve}}
            </mat-error>
            <mat-error *ngIf="loginFormGroup?.get('cardLastNumber').hasError('maxlength')">
              {{'mkb.card3dsecure.page.login.card.number.maxlength.error' | resolve}}
            </mat-error>
            <mat-error *ngIf="loginFormGroup?.get('cardLastNumber').hasError('minlength')" class="multiline-error">
              {{'mkb.card3dsecure.page.login.card.number.minlength.error' | resolve}}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="w-200">
            <div class="filed-title">{{'mkb.card3dsecure.page.login.card.name.title' | resolve}}</div>
            <input
              matInput
              safeTextInput
              formControlName="cardName">
            <mat-error *ngIf="loginFormGroup?.get('cardName').hasError('required')">
              {{'mkb.card3dsecure.common.required.error' | resolve}}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="w-200">
            <div class="filed-title">{{'mkb.card3dsecure.page.login.date.of.birth.title' | resolve}}</div>
            <input
              matInput
              datePickerInput
              formControlName="birthDate"
              [matDatepicker]="picker"
              [max]="maxBirthDate"
              [min]="minBirthDate">
            <mat-datepicker-toggle matSuffix [for]="picker">
              <mat-icon matDatepickerToggleIcon class="icon-calendar"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="loginFormGroup?.get('birthDate').hasError('required')">
              {{'mkb.card3dsecure.common.required.error' | resolve}}
            </mat-error>
            <mat-error *ngIf="loginFormGroup?.get('birthDate').hasError('invalidValue')">
              {{'mkb.card3dsecure.page.login.date.of.birth.invalid.error' | resolve}}
            </mat-error>
            <mat-error *ngIf="loginFormGroup?.get('birthDate').hasError('matDatepickerMax')" class="multiline-error">
              {{'mkb.card3dsecure.page.login.date.of.birth.max.error' | resolve}}
            </mat-error>
            <mat-error *ngIf="loginFormGroup?.get('birthDate').hasError('matDatepickerMin')" class="multiline-error">
              {{'mkb.card3dsecure.page.login.date.of.birth.min.error' | resolve}}
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="recaptchaEnabled">
            <re-captcha
              id="recaptcha-container"
              (resolved)="captchaResponse($event)"
              formControlName="recaptchaReactive"
              class="recaptcha-container"></re-captcha>
          </ng-container>
        </form>
        <button mat-flat-button color="primary" [disabled]="loginFormGroup.invalid" (click)="login()">
          {{'mkb.card3dsecure.page.login.submit.button.title' | resolve}}
        </button>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="side-bar-wrapper">
    <side-bar></side-bar>
  </div>
</div>
